import * as React from 'react';
import s from './ProductHat.scss';
import classNames from 'classnames';
import { withExperiments } from '@wix/wix-experiments-react';
import { Text } from '@wix/design-system';
import { withInjectedRootStore } from 'providers';
import { ProductHatController, ProductHatProps } from './ProductHat.controller';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { getSaleDiscountPercentage } from 'utils';
import { Theme } from 'enums';

const ProductHatComp: React.FC<ProductHatProps> = (props) => {
  const controller = React.useMemo(() => new ProductHatController(props), []);
  const { product, rootStore, isMobile = false } = props;
  const { isInSale } = rootStore.appStore;
  const hatKey = controller.hatKey;
  const isCurrentPlan = hatKey === 'productEntry.current_plan.hat';

  const { t } = useTranslation();
  const { theme: themeName } = usePageModeContext();
  const skin =
    themeName === Theme.Dayful
      ? undefined
      : isCurrentPlan
        ? 'standard'
        : 'premium';

  const discountPercentage = getSaleDiscountPercentage();

  return (
    <div
      className={classNames(
        {
          [s.popularHeader]: !isMobile,
          [s.mobilePopularHeader]: isMobile,
          [s.visible]: !!hatKey,
          [s.saleWrapper]: isInSale && !isCurrentPlan,
          [s.currentPlan]: isCurrentPlan,
        },
        themeName,
      )}
      data-hook='product-hat'
    >
      <Text
        className={classNames({
          [s.sale]: !!discountPercentage && isInSale && !isCurrentPlan,
          [s.mobileHat]: isMobile,
          [s.currentPlan]: isCurrentPlan,
        })}
        dataHook='hat-text'
        data-testid='hat-text'
        skin={skin}
        secondary={isCurrentPlan}
        weight='bold'
        size='tiny'
      >
        {t(hatKey, {
          percent:
            discountPercentage && product.isProductInSale
              ? discountPercentage
              : product.getDiscountPercent() ?? '',
        })}
      </Text>
    </div>
  );
};

export const ProductHat = withInjectedRootStore(
  withExperiments(ProductHatComp),
);
